import { FilterCheckbox } from '$components/Internal/Positions/Filters/FilterCheckbox';
import { ReactComponent as Search } from '$icons/SearchIcon.svg';
import Button from '$components/Buttons/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OpenToWorkTypes, QualityStatusTypes } from '$types/candidates.d';
import FilterMultiSelectWithGroups from '$components/Internal/Positions/Filters/FilterMultiSelectWithGroups/FilterMultiSelectWithGroups';
import { GroupedCountries } from '$constants/countries';
import { FilterInput } from '$components/Internal/Positions/Filters/FilterInput';
import { useGetAllTenantsQuery } from '$store/modules/tenant';
import { useGetAllJobCategoriesQuery } from '$store/modules/job-categories';

const SearchCandidatesFilter = () => {
  const { data: tenantData = [] } = useGetAllTenantsQuery();
  const tenantsOptions = tenantData?.map((tenant) => ({
    id: tenant.Id.toString(),
    text: tenant.title,
  }));

  const { data: jobCategoriesData = [] } = useGetAllJobCategoriesQuery();
  const jobCategoriesOptions = jobCategoriesData?.map((category) => ({
    id: category.Name,
    text: category.Name,
  }));

  const fileCategories = [
    { id: 'Video', text: 'Video' },
    { id: 'CV', text: 'CV' },
    { id: 'Reference', text: 'Reference' },
  ];

  const qualityStatusOptions = (
    Object.keys(QualityStatusTypes) as Array<keyof typeof QualityStatusTypes>
  ).reduce(
    (prev, act) => {
      const tempQualityStatus = {
        id: QualityStatusTypes[act],
        text: QualityStatusTypes[act],
      };
      prev.push(tempQualityStatus);
      return prev;
    },
    [] as { id: string; text: string }[]
  );

  const openToWorkOptions = (
    Object.keys(OpenToWorkTypes) as Array<keyof typeof OpenToWorkTypes>
  ).reduce(
    (prev, act) => {
      const tempOpenToWork = {
        id: OpenToWorkTypes[act] as string,
        text: OpenToWorkTypes[act] as string,
      };
      prev.push(tempOpenToWork);
      return prev;
    },
    [] as { id: string; text: string }[]
  );

  const [t] = useTranslation('global');
  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className="flex flex-row items-start">
      <div
        className={`${
          showSearch ? 'w-60' : 'w-0 overflow-hidden'
        } flex flex-col gap-4 rounded-r bg-white transform transition-all border-r-2 border-t-2 border-b-2 sticky top-0`}
      >
        <div className="p-4 flex flex-col gap-4">
          <FilterMultiSelectWithGroups
            title="Country" // dont add translation, this works as querystring param
            data={GroupedCountries}
            hideUnknownCheckbox
          />
          <FilterInput
            title="Salary" // dont add translation, this works as querystring param
            nameField
            regexValidation={/^\d+$/gi}
            validationErrorMessage={t('SearchCandidates.Filters.InvalidSalary')}
          />
          <FilterCheckbox
            title="Files" // dont add translation, this works as querystring param
            options={fileCategories}
          />
          <FilterCheckbox
            title="Tenant" // dont add translation, this works as querystring param
            options={tenantsOptions}
          />
          <FilterCheckbox
            title="Categories" // dont add translation, this works as querystring param
            options={jobCategoriesOptions}
          />
          <FilterCheckbox
            title="Quality Status" // dont add translation, this works as querystring param
            options={qualityStatusOptions}
          />
          <FilterCheckbox
            title="Open To Work" // dont add translation, this works as querystring param
            options={openToWorkOptions}
          />
        </div>
      </div>
      <div className="w-12 z-10 -ml-[2px] px-2 bg-white rounded-r whitespace-nowrap border-r-2 border-t-2 border-b-2 sticky top-0">
        <Button
          icon={Search}
          iconStyles={{ className: 'w-6 h-6' }}
          onClick={() => setShowSearch((prev) => !prev)}
        />
      </div>
    </div>
  );
};

export default SearchCandidatesFilter;
